/* eslint-disable no-underscore-dangle */
import { init as initImageZoom } from './image-zoom';

// TODO : we should better isolate media-zoom behavior and video behavior

const mzName = 'media-zoom';
const openClass = `${mzName}--opened`;
const buildedClass = `${mzName}--builded`;
const hasVideoClass = `${mzName}--has-video`;
const togglerName = 'js-toggle-media-zoom';
const sliderName = `${mzName}__slider`;
const slidesName = `${mzName}__slides`;
const customNavName = `${mzName}__custom-nav`;
const thumbnailsName = `${mzName}__thumbnails`;
const slideName = `${mzName}__slide`;
const thumbnailName = `${mzName}__thumbnail`;
const arrowsName = `${mzName}__thumbnails-arrows`;
const arrowsHidingClass = `${arrowsName}--hidden`;
const zoomHash = 'zoom=opened';
const lazyLoadClass = 'js-img-lazy';
const pictureLazyLoadClass = 'js-picture-lazy';
const videoNavBarClass = 'vjs-control-bar';

let zoomFWS = null;
let hasBeenOpened = false;
let _mz = null;
let _slider = null;
let _slides = null;
let _customNav = null;
let _thumbnails = null;
let _arrows = null;
let videoDataReceived;
let videosPerModel;
let currentModelId = null;
let allVideosThumbnailsFragment;

function addVideoScriptTag() {
  let brightcovescript;
  const scriptAlreadyThere = cube.$$('#brightcovescript').length > 0;

  if (!scriptAlreadyThere) {
    brightcovescript = document.createElement('script');
    brightcovescript.id = 'brightcovescript';
    brightcovescript.src = `https://players.brightcove.net/${window.brightCoveParameters.videoCloudAccountId}/${window.brightCoveParameters.playerID}_default/index.min.js`;
    cube.$('body').appendChild(brightcovescript);
  }
}

function updateNavDisplay() {
  const holderHeight = _customNav.offsetHeight;
  const thumbnailsHeight = _thumbnails.offsetHeight;
  const navIsNeed = thumbnailsHeight > holderHeight;

  if (navIsNeed) {
    _arrows.classList.remove(arrowsHidingClass);
  } else {
    _arrows.classList.add(arrowsHidingClass);
  }
}

function handleVideoInteractions() {
  const isAValidVideoSlide = slideIndex => {
    const slide = zoomFWS.el.slidesWithClones[slideIndex];
    if (!slide) {
      return false;
    }
    return slide.classList.contains(`${slideName}--video`) && !!slide.$('div.video-js');
  };

  const isLastSlide = slideIndex => slideIndex === zoomFWS.el.slidesWithClones.length - 3;

  const pauseVideo = slideIndex => {
    const slide = zoomFWS.el.slidesWithClones[slideIndex];
    window.videojs(slide.$('div.video-js').id).pause();
  };

  const updateClonePosition = slideIndex => {
    const slide = zoomFWS.el.slidesWithClones[slideIndex];
    const videoId = slide.$('.video-js').id;
    const cloneVideoId = `${videoId}--clone`;
    const currentTime = window.videojs(videoId).currentTime();
    if (slide.$('.video-js').classList.contains('vjs-has-started')) {
      window.videojs(cloneVideoId).volume(0);
      window.videojs(cloneVideoId).play();
      window.videojs(cloneVideoId).pause();
      window.videojs(cloneVideoId).currentTime(currentTime);
      window.videojs(videoId).currentTime(currentTime);
    }
  };

  // When slide is changing...
  zoomFWS.on('slideChanging', slideIndexes => {
    // If Leaving slide is a video...
    if (isAValidVideoSlide(slideIndexes.from))
      if (slideIndexes.from !== slideIndexes.to) {
        // ...and is different from Destination slide, pause video
        pauseVideo(slideIndexes.from);

        // if this leaving video slide is last one, we update video clone display
        if (isLastSlide(slideIndexes.from)) updateClonePosition(slideIndexes.from);
      }
  });
}

function resetZoom() {
  _mz.classList.remove('media-zoom--has-zoomed-picture');
  cube.$$('.media-zoom__slide--zoomed').forEach(sl => {
    sl.classList.remove('media-zoom__slide--zoomed');
  });
}

function resetZoomOnChange() {
  zoomFWS.on('slideChanging', slideIndexes => {
    if (slideIndexes.from !== slideIndexes.to) {
      resetZoom();
    }
  });
}

function handleModelChange() {
  const defaultId = cube.$$('.media-zoom__slides--alt')[0].dataset.modelId;
  currentModelId = defaultId;
  let savedVideoClones = [];
  const updateDom = newModelId => {
    const addableSlidesHolder = cube.$(`.${slidesName}--alt[data-model-id="${newModelId}"]`);
    const addableThumbnailsHolder = cube.$(`.${thumbnailsName}--alt[data-model-id="${newModelId}"]`);
    const addableSlides = addableSlidesHolder.$$(`.${slideName}`);
    const addableThumbnails = addableThumbnailsHolder.$$(`.${thumbnailName}`);
    const cloneSlides = _slides.$$('.fw-slider__clone');
    const movableSlides = _slides.$$(`.${slideName}:not(.${slideName}--video)`);
    const sliderNavs = _mz.$$('.fw-slider__inner-nav');
    const videoClones = _slides.$$(`.fw-slider__clone.${slideName}--video`);
    const newSlidesFragment = document.createDocumentFragment();
    const newThumbnailsFragment = document.createDocumentFragment();
    const flushContainers = () => {
      savedVideoClones = [];

      // Save video clones in a fragment before deleting them
      videoClones.forEach(videoClone => savedVideoClones.push(videoClone));
      cloneSlides.forEach(clone => clone.remove());
      movableSlides.forEach(slide => slide.remove());
      sliderNavs.forEach(nav => nav.remove());

      _thumbnails.innerHTML = '';
    };

    const buildContainer = () => {
      // delete potential existing full-width slider...
      if (zoomFWS) zoomFWS.destroy();
      // ...and build a new one
      zoomFWS = cube.fullWidthSlider('zoomSlider', _slider);
      if (!cube.ui.isDesktop()) {
        initImageZoom();
        resetZoomOnChange();
      }
    };

    flushContainers();

    // build a fragment with new slides
    addableSlides.forEach(slide => {
      const slideClone = slide.cloneNode(true);
      const slideImg = slideClone.$('img');
      const slidePict = slideClone.$('picture');

      // get id from dataset then remove the data-id
      slideClone.id = slideClone.dataset.id;
      slideClone.removeAttribute('data-id');

      if (slideImg) {
        slideImg.classList.add(pictureLazyLoadClass);
      }

      if (slidePict) {
        slidePict.classList.add(pictureLazyLoadClass);
      }

      newSlidesFragment.appendChild(slideClone);
    });

    // build a fragment with new thumbnails
    addableThumbnails.forEach(thumbnail => {
      const thumbnailClone = thumbnail.cloneNode(true);

      thumbnailClone.$('picture').classList.add(lazyLoadClass);
      newThumbnailsFragment.appendChild(thumbnailClone);
    });

    // add fragments to dom, then build a new full-width slider
    _slides.insertBefore(newSlidesFragment, _slides.firstChild);
    _thumbnails.appendChild(newThumbnailsFragment);

    // add video thumbnails for the current model
    if (allVideosThumbnailsFragment) {
      const currentModelVideoThumbnails = Array.from(allVideosThumbnailsFragment.children).filter(isCurrentModelVideo);
      currentModelVideoThumbnails.forEach(thumbnail => _thumbnails.appendChild(thumbnail.cloneNode(true)));
    }

    buildContainer();
    _thumbnails.$$('img').forEach(img => {
      img.addEventListener('load', () => {
        if (img.src === img.dataset.src) updateNavDisplay();
      });
    });
    updateNavDisplay();

    if (hasVideos()) {
      let cloneForValue;
      // Add data information to remove unwanted video clones
      _slides.$$(`.fw-slider__clone.${slideName}--video`).forEach(videoClone => {
        cloneForValue = `video-${videoClone.$('.video-js').id.replace('--clone', '')}`;
        videoClone.dataset.cloneFor = cloneForValue;
      });

      // Replace new clones with initial video clones that were saved in an array
      if (savedVideoClones.length) {
        savedVideoClones.forEach(savedVideoClone => {
          cloneForValue = savedVideoClone.dataset.cloneFor;
          const slideToReplace = _slides.$(`[data-clone-for="${cloneForValue}"]`);

          slideToReplace.parentNode.insertBefore(savedVideoClone, slideToReplace);
          slideToReplace.remove();
        });
      }

      handleVideoInteractions();
    }

    revealVideoButton();
  };

  cube.event.on('modelChanged', newModelId => {
    currentModelId = newModelId;
    updateDom(newModelId);
  });

  updateDom(defaultId);
}

function handleDom() {
  const isNavChild = (slide, child) => {
    let node = child.parentNode;
    while (node !== null) {
      if (node === slide.$(`.${videoNavBarClass}`)) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  };
  // return true if the event target is video navigation (or a child of it)
  const isControl = (event, slide) =>
    event.target.classList.contains(videoNavBarClass) || isNavChild(slide, event.target);
  const stopPropagationOnNavInteraction = (event, slide) => {
    // If touched element is video control, we don't interact with full-width slider
    if (isControl(event, slide)) {
      event.stopPropagation();
    }
  };
  const flushVideoContent = () => {
    const videoToggler = cube.$('.product-picture__video-toggler');
    const videoNavigationItem = cube.$('.description-product-nav li a[href="#VideoFloor"]');
    if (videoToggler) videoToggler.parentNode.removeChild(videoToggler);
    if (videoNavigationItem) videoNavigationItem.parentNode.remove();
    _mz.classList.remove(hasVideoClass);
  };

  const handleVideosThenLaunch = () => {
    const buildVideoDom = videos => {
      // For each video, we build a slide and its thumbnail and append them in the slider
      videos.forEach(video => {
        const slide = document.createElement('div');
        const videotag = document.createElement('video');

        // Build of the slide
        slide.classList.add(slideName);
        slide.classList.add(`${slideName}--video`);
        slide.id = `video-${video.referenceId}`;

        videotag.id = video.referenceId;
        videotag.dataset.videoId = video.id;
        videotag.dataset.account = window.brightCoveParameters.videoCloudAccountId;
        videotag.dataset.player = window.brightCoveParameters.playerID;
        videotag.dataset.embed = 'default';
        videotag.classList.add('video-js');
        videotag.setAttribute('controls', 'true');

        slide.appendChild(videotag);
        _slides.appendChild(slide);

        // Bind pointer events

        // -- prevent default on nav elements
        slide.addEventListener('touchstart', event => stopPropagationOnNavInteraction(event, slide));
        slide.addEventListener('mousedown', event => stopPropagationOnNavInteraction(event, slide));

        // -- if slide is clicked (without swipe), we play/pause the video
        slide.addEventListener('click', event => {
          const distancemoved = zoomFWS.distancemoved !== 0;

          if (!distancemoved && !isControl(event, slide)) {
            if (window.videojs(videotag.id).paused()) {
              window.videojs(videotag.id).play();
            } else {
              window.videojs(videotag.id).pause();
            }
          }
        });
      });
    };

    // If slider shall contain video, then we have to wait for brightcove data to be received
    const _videoDataReceived = videos => {
      if ( videos && videos.length ) {
        buildVideoDom(videos);
        handleModelChange();
        handleVideoInteractions();
        revealVideoButton();
      } else {
        // No video data were received, therefore we flush video elems and launch without
        flushVideoContent();
        handleModelChange();
      }
    };

    _videoDataReceived(videoDataReceived);
  };

  // Move the zoom module at the end of the body
  cube.$('body').appendChild(_mz);

  // Every potential Lazy loadable img has his lazy-load class removed
  _mz.$$(`.${lazyLoadClass}`).forEach(img => img.classList.remove(lazyLoadClass));
  _mz.$$(`.${pictureLazyLoadClass}`).forEach(picture => picture.classList.remove(pictureLazyLoadClass));

  // Maintain zoom as invisible but display it so it can launch animation
  _mz.classList.add(buildedClass);

  // 4 - If the product contains videos, build the dom for the video slides
  //     and then launch the fullWidthSlider with proper modelId (if it doesn't, launch it now)
  if (hasVideos()) {
    handleVideosThenLaunch();
  } else {
    handleModelChange();
  }
}

function addHash() {
  const url = window.location;

  if (url.hash) {
    url.href = `${url.href.substring(0, url.href.lastIndexOf(url.hash))}#${zoomHash}`;
  } else {
    url.href = `${url.hash}#${zoomHash}`;
  }
}

function closeZoom() {
  _mz.classList.remove(openClass);
  cube.$('html').style.removeProperty('overflow');

  resetZoom();

  // If needed, pause palying video on closing
  if (hasVideos()) {
    const slide = _slides.$$(`.${slideName}`)[zoomFWS.index];
    if (slide.classList.contains(`${slideName}--video`)) window.videojs(slide.$('div.video-js').id).pause();
  }
}

function toggleZoom(event) {
  event.preventDefault();

  const toggler = event.target.classList.contains(togglerName) ? event.target : event.target.closest(`.${togglerName}`);

  if (_mz.classList.contains(openClass)) {
    // Close ---
    closeZoom();
    window.history.back();
  } else {
    // Open ---

    // on first open
    if (!hasBeenOpened) {
      hasBeenOpened = true;
      if (hasVideos()) {
        addVideoScriptTag();
      }
    }

    // Trigger Load for every thumbnails
    if (_thumbnails.$$(`.${lazyLoadClass}`).length) {
      _thumbnails.$$(`.${lazyLoadClass}`).forEach(img => cube.lazyload.display(img));
    }

    // If toggler href targets a slide, then we open slider on said slide
    if (
      (toggler.hasAttribute('href') && toggler.getAttribute('href') !== '#') ||
      (toggler.hasAttribute('data-href') && toggler.getAttribute('data-href') !== '#')
    ) {
      const slidesWithoutClones = _slides.$$(`.${slideName}:not(.fw-slider__clone)`);
      const targetHref = toggler.getAttribute('href') || toggler.getAttribute('data-href');
      const targetId = targetHref.replace('#', '');
      const targetSlide = cube.$id(targetId);
      const targetIndex = [].indexOf.call(slidesWithoutClones, targetSlide);

      if (targetIndex > -1 && zoomFWS.inited) zoomFWS.goto(targetIndex);

      // if target is a video slide : Autoplay
      if (targetSlide && targetSlide.classList.contains(`${slideName}--video`)) {
        const videoElem = targetSlide.$('.video-js');
        const videoId = videoElem.id;

        // Builded brightcove video is an id'ed div tag, else it is a video tag
        // If it's already built, we can play it, if not we add an autoplay attribute
        if (videoElem.tagName === 'DIV') {
          window.videojs(videoId).play();
        } else {
          videoElem.setAttribute('autoplay', 'true');
        }
      }
    }

    // Open and add hash
    _mz.classList.add(openClass);
    cube.$('html').style.overflow = 'hidden';
    addHash();
  }
}

function handleOpening() {
  const url = window.location;
  const removeHash = () => {
    const href = url.href.substring(0, url.href.lastIndexOf(`#${zoomHash}`));
    window.history.pushState('', '', href);
  };
  const closeOnHistoryBack = () => {
    if (url.href.indexOf(zoomHash) < 0 && _mz.classList.contains(openClass)) {
      closeZoom();
    }
  };

  if (url.href.indexOf(zoomHash) > -1) {
    removeHash();
  }

  window.addEventListener('popstate', closeOnHistoryBack);

  cube.$('body.product-page').addEventListener('click', event => {
    const isToggler = event.target.classList.contains(togglerName);
    const isTogglerChild = !!event.target.closest(`.${togglerName}`);
    const sliderIsInited = _slider.classList.contains('fw-slider--js-inited');

    if (sliderIsInited && (isToggler || isTogglerChild)) toggleZoom(event);
  });
}

function handleArrows() {
  const btns = _arrows.$$('button');
  const step = 0.8;

  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      const direction = btn.dataset.direction === 'up' ? '-' : '+';
      const height = _customNav.offsetHeight * step;
      $(`.${customNavName}`).scrollTo(`${direction}=${height}`, 150);
    });
  });
}

function listenForResize() {
  cube.event.on('resize', cube.debounce(() => updateNavDisplay(), 75));
}

function preventDefaultPinchZoom(event) {
  const touchesNumber = event.touches ? event.touches.length : 1;

  if (touchesNumber > 1) {
    event.preventDefault();
  }
}

function revealVideoButton() {
  const videoToggler = cube.$('.product-picture__video-toggler');
  const currentModelVideos = videosPerModel[currentModelId];
  if (videoToggler && currentModelVideos && currentModelVideos.length > 0) {
    videoToggler.classList.add('product-picture__video-toggler--visible');
    videoToggler.dataset.href = `#video-${currentModelVideos[0].referenceId}`;
  } else if(videoToggler) {
    videoToggler.classList.remove('product-picture__video-toggler--visible');
  }
}

export const hasVideos = () => cube.$id(mzName).classList.contains(hasVideoClass);

export const setVideoDataReceived = value => {
  videoDataReceived = value;

  allVideosThumbnailsFragment = document.createDocumentFragment();
  if( videoDataReceived && videoDataReceived.length ) {
    videoDataReceived.forEach(video => {
      const a = document.createElement('a');
      const img = document.createElement('img');
      a.href = `#video-${video.referenceId}`;
      a.classList.add(thumbnailName);
      a.classList.add(`${thumbnailName}--video`);

      img.classList.add(lazyLoadClass);
      img.src = '/assets/images/img-lazy.gif';
      img.dataset.src = video.thumbnailURL;
      img.alt = video.name;
      img.height = 120;
      img.width = 120;

      a.appendChild(img);
      allVideosThumbnailsFragment.appendChild(a.cloneNode(true));
    });
  }
};

export function init() {
  _mz = cube.$id(mzName);

  _slider = cube.$(`#${sliderName}`);
  _slides = _slider.$(`.${slidesName}`);

  _customNav = cube.$(`.${customNavName}`);
  _thumbnails = _customNav.$(`.${thumbnailsName}`);

  _arrows = cube.$(`.${arrowsName}`);

  videosPerModel = getVideosPerModel();

  handleDom();
  handleOpening();
  handleArrows();
  listenForResize();

  _mz.addEventListener('touchmove', preventDefaultPinchZoom);
}

function getVideosPerModel() {
  const modelsData = JSON.parse(cube.$id('pdm_productdetailsmaincartridge').dataset.pdmjsmodels);
  const videosData = {};
  modelsData.forEach(data => {
    videosData[data.id] =
      data.media &&
      data.media.videos &&
      data.media.videos.map(v => ({
        referenceId: v.referenceId,
      }));
  });
  return videosData;
}

function isCurrentModelVideo(videoThumbnail) {
  const videoId = videoThumbnail.getAttribute('href').replace('#video-', '');
  const currentModelVideos = videosPerModel[currentModelId];

  return currentModelVideos.find(video => video.referenceId === videoId);
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/media-zoom.js